<template>
    <div class="modal-box remove-user" v-loading="loading">
        <div class="modal-box-inner">
            <div class="modal-box-header" v-if="this.header">
                x
            </div>
            <div class="modal-box-content">

              <div class="modal-box-content-form-row">
                <div class="modal-box-content-form-text">
                  Are you sure you want to remove <br/>
                  {{this.data.usersEmail.join(', ')}}?
                </div>
              </div>

                <div class="modal-box-actions">

                    <a href="#" @click.prevent="removeUsers()" class="modal-box-actions-item button">remove</a>
                    <a href="#" @click.prevent="close()" class="modal-box-actions-item button white">Cancel</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'

export default {
  props: {
    header: {
      type: [Boolean, Object]
    },
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  name: 'UserRemoveModal',
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.close()
      }
    })
  },
  methods: {
    removeUsers () {
      this.loading = true
      return HTTP({
        method: 'DELETE',
        url: 'api/v1/users',
        crossdomain: true,
        data: {
          id: this.data.usersId
        }
      }).then(response => {
        this.loading = false
        if (response.data) {
          this.$notify({
            // title: 'Success',
            message: 'Deleted successfully',
            type: 'success',
            position: 'bottom-right',
            duration: 1750
          })
          this.close()
          EventBus.$emit('reload-users')
        }
      }).catch((error) => {
        this.loading = false
        this.$notify({
          // title: 'Error',
          dangerouslyUseHTMLString: true,
          message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
          type: 'error',
          position: 'bottom-right',
          duration: 1750
        })
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
